import React from "react";
import { formatarData } from "../../../../components/Formatters/DateTime";

const ReclamacaoNfpCard = ({ listaReclamacao }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Reclamações da Nota Potiguar</b>
      </div>
      <div className="card-body">
        <center>
          <table className="table table-striped table-bordered" width="100%">
            <thead>
              <tr>
                <th>
                  <center>Data</center>
                </th>
                <th>
                  <center>Tipo</center>
                </th>
                <th>
                  <center> </center>
                </th>
              </tr>
            </thead>
            <tbody>
              {listaReclamacao?.map((reclamacao) => (
                <tr>
                  <td>
                    <center>{formatarData(reclamacao.dataInclusao, "dd/MM/yyyy")}</center>
                  </td>
                  <td>
                    <center>{reclamacao.tipo}</center>
                  </td>
                  <td>
                    <a href={reclamacao.link}>Ver Reclamação</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      </div>
    </div>
  </div>
);

export default ReclamacaoNfpCard;
